<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 179 179"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>movie-goers</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="89.2666667"
        cy="89.2666667"
        r="88.8888889" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-1197.000000, -230.000000)">
        <g
          id="movie-goers"
          transform="translate(1197.000000, 230.000000)">
          <mask
            id="mask-2"
            fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g
            id="Oval"
            fill-rule="nonzero" />
          <g
            id="Background"
            mask="url(#mask-2)"
            class="fill-extra-light"
            fill-rule="nonzero">
            <g
              id="Oval"
              transform="translate(-1.222222, 0.000000)">
              <circle
                cx="89"
                cy="89.4444444"
                r="88.8888889" />
            </g>
          </g>
          <g
            id="Scene"
            mask="url(#mask-2)">
            <g transform="translate(31.111111, -2.222222)">
              <g
                id="Group"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd">
                <rect
                  id="Rectangle"
                  class="stroke fill-light"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="86.6666667"
                  y="0"
                  width="76.6666667"
                  height="183.333333" />
                <rect
                  id="Rectangle"
                  class="fill-white"
                  fill-rule="nonzero"
                  x="78.8888889"
                  y="132.222222"
                  width="87.7777778"
                  height="51.1111111" />
                <rect
                  id="Rectangle"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  x="78.8888889"
                  y="132.222222"
                  width="87.7777778"
                  height="51.1111111" />
                <path
                  id="Path"
                  d="M104.444444,52.2222222 L145.555556,52.2222222 C148.010154,52.2222222 150,54.2120678 150,56.6666667 L150,125.555556 L100,125.555556 L100,56.6666667 C100,54.2120678 101.989846,52.2222222 104.444444,52.2222222 Z"
                  class="stroke fill-light"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M100,56.6666667 L100,113.333633 L109.155556,113.333633 C110.242231,113.351058 111.182295,112.580206 111.377778,111.511111 C112.548455,104.873603 118.3156,100.034613 125.055556,100.034613 C131.795511,100.034613 137.562656,104.873603 138.733333,111.511111 C138.928816,112.580206 139.868881,113.351058 140.955556,113.333633 L150,113.333633 L150,56.6666667 C150,54.2120678 148.010154,52.2222222 145.555556,52.2222222 L104.444444,52.2222222 C101.989846,52.2222222 100,54.2120678 100,56.6666667 Z"
                  class="fill-light"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M142.355556,52.2222222 L104.444444,52.2222222 C101.989846,52.2222222 100,54.2120678 100,56.6666667 L100,94.6 L142.355556,52.2222222 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M100,56.6666667 L100,113.333633 L109.155556,113.333633 C110.242231,113.351058 111.182295,112.580206 111.377778,111.511111 C112.548455,104.873603 118.3156,100.034613 125.055556,100.034613 C131.795511,100.034613 137.562656,104.873603 138.733333,111.511111 C138.928816,112.580206 139.868881,113.351058 140.955556,113.333633 L150,113.333633 L150,56.6666667 C150,54.2120678 148.010154,52.2222222 145.555556,52.2222222 L104.444444,52.2222222 C101.989846,52.2222222 100,54.2120678 100,56.6666667 Z"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M103.333333,33.3332588 L94.2888889,33.3332588 C93.87555,33.3285579 93.4937285,33.5536355 93.2977516,33.9175927 C93.1017746,34.28155 93.1240427,34.7242142 93.3555556,35.0666667 L95.1555556,37.7777778 C95.5525173,38.4653357 95.5525173,39.3124421 95.1555556,40 L92.9333333,43.8444444 C92.744714,44.1891697 92.7522049,44.6078855 92.953034,44.9456435 C93.153863,45.2834015 93.5181587,45.4899631 93.9111111,45.4888931 L101.111111,45.4888931 C102.338411,45.4888931 103.333333,44.4939661 103.333333,43.2666667 L103.333333,33.3332588 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M103.333333,33.3332588 L94.2888889,33.3332588 C93.87555,33.3285579 93.4937285,33.5536355 93.2977516,33.9175927 C93.1017746,34.28155 93.1240427,34.7242142 93.3555556,35.0666667 L95.1555556,37.7777778 C95.5525173,38.4653357 95.5525173,39.3124421 95.1555556,40 L92.9333333,43.8444444 C92.744714,44.1891697 92.7522049,44.6078855 92.953034,44.9456435 C93.153863,45.2834015 93.5181587,45.4899631 93.9111111,45.4888931 L101.111111,45.4888931 C102.338411,45.4888931 103.333333,44.4939661 103.333333,43.2666667 L103.333333,33.3332588 Z"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M104.311111,27.8666667 C110.533636,23.5027058 117.95534,21.1737193 125.555556,21.2 L125.555556,21.2 C132.797883,21.2091788 139.877294,23.3500049 145.911111,27.3555556 L146.777778,27.9555556 C147.398634,28.3644078 147.773932,29.0566242 147.777778,29.8 L147.777778,41.5777778 L145.911111,40.3333333 C139.883749,36.3114857 132.801541,34.1620821 125.555556,34.1555556 L125.555556,34.1555556 C117.543102,34.1778636 109.75093,36.7804488 103.333333,41.5777778 L103.333333,29.8 C103.301764,29.0295622 103.671837,28.2978273 104.311111,27.8666667 L104.311111,27.8666667 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M163.822222,132.222222 L79.3777778,132.222222 C77.5368286,132.222222 76.0444444,130.729838 76.0444444,128.888889 L76.0444444,128.888889 C76.0444444,127.04794 77.5368286,125.555556 79.3777778,125.555556 L163.822222,125.555556 C165.663171,125.555556 167.155556,127.04794 167.155556,128.888889 L167.155556,128.888889 C167.155556,130.729838 165.663171,132.222222 163.822222,132.222222 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M147.777778,33.888779 L156.8,33.888779 C157.199731,33.8832795 157.571662,34.0928399 157.773951,34.4376522 C157.976241,34.7824644 157.977702,35.2093667 157.777778,35.5555556 L155.977778,38.2444444 C155.580816,38.9320024 155.580816,39.7791087 155.977778,40.4666667 L158.2,44.3111111 C158.401482,44.6506106 158.403425,45.0725711 158.205078,45.4139118 C158.006732,45.7552525 157.639168,45.9624996 157.244444,45.9555556 L147.777778,45.9555556 L147.777778,33.888779 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M2.22222222,166.111111 C2.22222222,169.17936 4.70952917,171.666667 7.77777778,171.666667 C10.8460264,171.666667 13.3333333,169.17936 13.3333333,166.111111 L13.3333333,163.888889 L2.22222222,163.888889 L2.22222222,166.111111 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M76.2222222,158.755556 C75.5111111,157.822222 74.8444444,156.844444 74.2,155.866667 L74.0666667,155.866667 L65.4444444,162.222222 C65.1683743,162.425802 64.848924,162.562709 64.5111111,162.622222 C65.1777778,163.688889 65.8888889,164.844444 66.7333333,165.777778 L66.7333333,165.777778 C67.9348933,167.636875 70.0684282,168.676168 72.2729747,168.476262 C74.4775213,168.276357 76.3893093,166.870239 77.236859,164.825331 C78.0844086,162.780423 77.7278665,160.434154 76.3111111,158.733333 L76.2222222,158.755556 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M74.7555556,153.333333 C70.8782332,144.978801 68.8758542,135.877078 68.8888889,126.666667 L68.8888889,123.333333 C68.8888886,104.310192 53.4675856,88.8888894 34.4444444,88.8888894 C15.4213033,88.8888894 -7.89491929e-15,104.310192 -7.89491929e-15,123.333333 L-7.89491929e-15,162.222222 C-7.89491929e-15,163.449522 0.994922778,164.444444 2.22222222,164.444444 L13.3333333,164.444444 L13.3333333,162.222222 L55.5555556,162.222222 L55.5555556,132.933333 C55.5755137,142.828069 57.8557479,152.587472 62.2222222,161.466667 C62.5184767,162.051901 63.0581519,162.476354 63.696718,162.626353 C64.335284,162.776352 65.0074975,162.636571 65.5333333,162.244444 L74.1555556,155.977778 C74.9325134,155.334608 75.1788656,154.248833 74.7555556,153.333333 Z"
                  class="fill-light"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M74.7555556,153.333333 C70.8782332,144.978801 68.8758542,135.877078 68.8888889,126.666667 L68.8888889,123.333333 C68.8888886,104.310192 53.4675856,88.8888894 34.4444444,88.8888894 C15.4213033,88.8888894 -7.89491929e-15,104.310192 -7.89491929e-15,123.333333 L-7.89491929e-15,162.222222 C-7.89491929e-15,163.449522 0.994922778,164.444444 2.22222222,164.444444 L13.3333333,164.444444 L13.3333333,162.222222 L55.5555556,162.222222 L55.5555556,132.933333 C55.5755137,142.828069 57.8557479,152.587472 62.2222222,161.466667 C62.5184767,162.051901 63.0581519,162.476354 63.696718,162.626353 C64.335284,162.776352 65.0074975,162.636571 65.5333333,162.244444 L74.1555556,155.977778 C74.9325134,155.334608 75.1788656,154.248833 74.7555556,153.333333 Z"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <rect
                  id="Rectangle"
                  class="fill-light"
                  fill-rule="nonzero"
                  transform="translate(34.422222, 168.611111) rotate(180.000000) translate(-34.422222, -168.611111) "
                  x="13.3111111"
                  y="155.555556"
                  width="42.2222222"
                  height="26.1111111" />
                <rect
                  id="Rectangle"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  transform="translate(34.422222, 168.611111) rotate(180.000000) translate(-34.422222, -168.611111) "
                  x="13.3111111"
                  y="155.555556"
                  width="42.2222222"
                  height="26.1111111" />
                <line
                  id="Path"
                  x1="34.4444444"
                  y1="168.288889"
                  x2="34.4444444"
                  y2="181.666667"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <rect
                  id="Rectangle"
                  class="fill-white"
                  fill-rule="nonzero"
                  transform="translate(52.755556, 171.666667) rotate(180.000000) translate(-52.755556, -171.666667) "
                  x="49.9777778"
                  y="162.222222"
                  width="5.55555556"
                  height="18.8888889" />
                <rect
                  id="Rectangle"
                  class="fill-white"
                  fill-rule="nonzero"
                  transform="translate(16.088889, 171.666667) rotate(180.000000) translate(-16.088889, -171.666667) "
                  x="13.3111111"
                  y="162.222222"
                  width="5.55555556"
                  height="18.8888889" />
                <rect
                  id="Rectangle"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  transform="translate(52.755556, 171.666667) rotate(180.000000) translate(-52.755556, -171.666667) "
                  x="49.9777778"
                  y="162.222222"
                  width="5.55555556"
                  height="18.8888889" />
                <rect
                  id="Rectangle"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  transform="translate(16.088889, 171.666667) rotate(180.000000) translate(-16.088889, -171.666667) "
                  x="13.3111111"
                  y="162.222222"
                  width="5.55555556"
                  height="18.8888889" />
                <path
                  id="Path"
                  d="M13.3111111,94.8888889 L55.5333333,94.8888889 L55.5333333,141.111111 C55.5333333,152.770456 46.0815669,162.222222 34.4222222,162.222222 L34.4222222,162.222222 C22.7628775,162.222222 13.3111111,152.770456 13.3111111,141.111111 L13.3111111,94.8888889 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  transform="translate(34.422222, 128.555556) rotate(-180.000000) translate(-34.422222, -128.555556) " />
                <path
                  id="Path"
                  d="M34.4444444,85 C31.7885141,85.0076096 29.1532405,84.5332603 26.6666667,83.6 L26.6666667,93.7111111 C26.6912798,96.4768184 28.191062,99.0188221 30.6,100.377778 L30.6,100.377778 C32.9929651,101.738691 35.9270613,101.733271 38.3149822,100.363526 C40.7029031,98.993782 42.1888713,96.4637922 42.2222222,93.7111111 L42.2222222,83.6 C39.7351268,84.5313635 37.1002023,85.0056499 34.4444444,85 L34.4444444,85 Z"
                  class="fill-white"
                  fill-rule="nonzero" />
                <path
                  id="Path"
                  d="M34.4444444,85 C31.7885141,85.0076096 29.1532405,84.5332603 26.6666667,83.6 L26.6666667,93.7111111 C26.6912798,96.4768184 28.191062,99.0188221 30.6,100.377778 L30.6,100.377778 C32.9929651,101.738691 35.9270613,101.733271 38.3149822,100.363526 C40.7029031,98.993782 42.1888713,96.4637922 42.2222222,93.7111111 L42.2222222,83.6 C39.7351268,84.5313635 37.1002023,85.0056499 34.4444444,85 L34.4444444,85 Z"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <circle
                  id="Oval"
                  class="fill-white"
                  fill-rule="nonzero"
                  cx="34.4444444"
                  cy="130"
                  r="12.2222222" />
                <circle
                  id="Oval"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  cx="34.4444444"
                  cy="130"
                  r="12.2222222" />
                <line
                  id="Path"
                  x1="42.2222222"
                  y1="120.577778"
                  x2="42.2222222"
                  y2="139.422222"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="26.6666667"
                  y1="120.577778"
                  x2="26.6666667"
                  y2="139.422222"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="31.1111111"
                  y1="118.244444"
                  x2="31.1111111"
                  y2="141.755556"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="37.7777778"
                  y1="118.244444"
                  x2="37.7777778"
                  y2="141.755556"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M75.2222222,161.066667 L69.1333333,165.977778 C68.6853861,166.360852 68.4079736,166.906192 68.3621306,167.493815 C68.3162877,168.081438 68.5057701,168.663202 68.8888889,169.111111 L73.9111111,175.555556 C74.2782668,176.019958 74.8155501,176.318664 75.4037829,176.385413 C75.9920156,176.452163 76.5825675,176.281439 77.0444444,175.911111 L83.1333333,171 C83.6678722,170.566671 83.9715108,169.910155 83.9555556,169.222222 C83.906101,167.912726 84.4838883,166.658102 85.5111111,165.844444 C86.5524895,165.006423 87.9319914,164.717306 89.2222222,165.066667 C89.9147057,165.16829 90.6145997,164.937737 91.1111111,164.444444 L93.3333333,162.711111 C93.7943994,162.340726 94.0888049,161.801831 94.1513679,161.213739 C94.2139309,160.625646 94.03949,160.036874 93.6666667,159.577778 L88.4222222,153.333333 C88.0518373,152.872267 87.5129424,152.577862 86.92485,152.515299 C86.3367576,152.452736 85.7479854,152.627177 85.2888889,153 L83.0666667,154.755556 C82.5321278,155.188885 82.2284892,155.845401 82.2444444,156.533333 C82.2903444,157.835843 81.7125597,159.082207 80.6888889,159.888889 C79.677972,160.717349 78.3361916,161.021925 77.0666667,160.711111 C76.4295197,160.551186 75.7542634,160.681356 75.2222222,161.066667 L75.2222222,161.066667 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <line
                  id="Path"
                  x1="83.9111111"
                  y1="163.777778"
                  x2="82.3333333"
                  y2="161.822222"
                  class="stroke"
                  stroke-width="2.22222222"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
                <path
                  id="Path"
                  d="M76.7111111,166.866667 L77.7777778,168.2 C78.485189,169.092874 78.3467896,170.387897 77.4666667,171.111111 L77.4666667,171.111111 C76.5511006,171.764868 75.2913972,171.631263 74.5333333,170.8 L73.4666667,169.466667 C72.8252471,168.598828 72.9504565,167.385261 73.7555556,166.666667 L73.7555556,166.666667 C74.6480024,165.971219 75.920492,166.057327 76.7111111,166.866667 L76.7111111,166.866667 Z"
                  class="stroke fill-white"
                  stroke-width="2.22222222"
                  fill-rule="nonzero"
                  stroke-linecap="round"
                  stroke-linejoin="round" />
              </g>
              <path
                id="Path"
                d="M56.6666667,57.7777778 L56.6666667,52.2222222 C56.6666667,39.9492278 46.7174389,30 34.4444444,30 C22.17145,30 12.2222222,39.9492278 12.2222222,52.2222222 L12.2222222,57.7777778 C9.76762333,57.7777778 7.77777778,59.7676233 7.77777778,62.2222222 C7.77777778,64.6768211 9.76762333,66.6666667 12.2222222,66.6666667 L12.4888889,66.6666667 C14.2102231,77.4510108 23.5124785,85.3862444 34.4333333,85.3862444 C45.3541881,85.3862444 54.6564435,77.4510108 56.3777778,66.6666667 L56.6666667,66.6666667 C59.1212656,66.6666667 61.1111111,64.6768211 61.1111111,62.2222222 C61.1111111,59.7676233 59.1212656,57.7777778 56.6666667,57.7777778 L56.6666667,57.7777778 Z"
                class="stroke fill-white"
                stroke-width="2.22222222"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M46.6666667,60 C46.0981723,58.663178 44.7860132,57.7953047 43.3333333,57.7953047 C41.8806534,57.7953047 40.5684944,58.663178 40,60"
                class="stroke"
                stroke-width="2.22222222"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M28.8888889,60 C28.3203945,58.663178 27.0082354,57.7953047 25.5555556,57.7953047 C24.1028757,57.7953047 22.7907166,58.663178 22.2222222,60"
                class="stroke"
                stroke-width="2.22222222"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <ellipse
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="21.6666667"
                cy="68.1555556"
                rx="2.77777778"
                ry="2.46666667" />
              <ellipse
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="47.2222222"
                cy="68.1555556"
                rx="2.77777778"
                ry="2.46666667" />
              <path
                id="Path"
                d="M27.7777778,73.3333333 C31.5111111,76.8888889 37.3777778,76.8888889 41.1111111,73.3333333"
                class="stroke"
                stroke-width="2.22222222"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M56.6666667,56.6666667 C63.2,43.5777778 56.3777778,36.8 54.0666667,34.9777778 C54.2900633,34.4566789 54.4180218,33.899683 54.4444444,33.3333333 C54.4444444,24.7333333 48,17.7777778 36.6666667,17.7777778 C34.4444444,17.7777778 23.3333333,19.6666667 25.5555556,11.1111111 C12.2222222,16.6666667 13.3333333,33.3333333 13.3333333,33.3333333 C13.3764367,34.1226967 13.6212741,34.8878136 14.0444444,35.5555556 C11.3111111,38.0888889 6.28888889,44.7777778 12.2222222,56.6 C12.2222222,56.6 19.8444444,48.9555556 19.9777778,40.1777778 C28.7960706,45.768081 40.0483738,45.768081 48.8666667,40.1777778 C49.0444444,49.0222222 56.6666667,56.6666667 56.6666667,56.6666667 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M56.6666667,56.6666667 C63.2,43.5777778 56.3777778,36.8 54.0666667,34.9777778 C54.2900633,34.4566789 54.4180218,33.899683 54.4444444,33.3333333 C54.4444444,24.7333333 48,17.7777778 36.6666667,17.7777778 C34.4444444,17.7777778 23.3333333,19.6666667 25.5555556,11.1111111 C12.2222222,16.6666667 13.3333333,33.3333333 13.3333333,33.3333333 C13.3764367,34.1226967 13.6212741,34.8878136 14.0444444,35.5555556 C11.3111111,38.0888889 6.28888889,44.7777778 12.2222222,56.6 C12.2222222,56.6 19.8444444,48.9555556 19.9777778,40.1777778 C28.7960706,45.768081 40.0483738,45.768081 48.8666667,40.1777778 C49.0444444,49.0222222 56.6666667,56.6666667 56.6666667,56.6666667 Z"
                class="stroke"
                stroke-width="2.22222222"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
